import { Bar, BarChart, LabelList, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { numberFormatter } from "../../utils";

const TargetSpend = (props: any) => {

    const customTooltip = ({ active, payload }: any) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            return (
                <div className="custom-tooltip">
                    <p className="label" style={{ padding: "0", margin: "0" }}>
                        <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Quarter : </label>
                        <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                            {data.quarter}</label></p>
                    {data.actual > 0 && <p className="label" style={{ padding: "0", margin: "0" }}>
                        <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Actual Spend($) : </label>
                        <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                            {numberFormatter(data.actual, 2, '$')}</label></p>}
                    {(data.forecastedSpend > 0 || data.spendNeededForNextTier > 0) && <>
                        <p className="label" style={{ padding: "0", margin: "0" }}>
                            <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Forecasted Spend($) : </label>
                            <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                                {numberFormatter(data.forecastedSpend, 2, '$')}</label></p>

                        <p className="label" style={{ padding: "0", margin: "0" }}>
                            <label style={{ color: "#C8C8C8", fontSize: "10px", fontWeight: "normal" }}>Spend for Next Tier($) : </label>
                            <label style={{ color: "#EAEAEA", fontSize: "10px", fontWeight: "bold" }}>
                                {numberFormatter(data.spendNeededForNextTier, 2, '$')}</label></p>
                    </>
                    }
                </div>
            )
        }
    }

    const updateLegend = (value: any) => {
        let year = new Date().getFullYear();
        if (value == 'actual') {
            return year + ' Actuals';
        } else if (value == 'forecastedSpend') {
            return 'Forecasted Spend';
        } else if (value == 'spendNeededForNextTier') {
            return 'Spend Needed for next tier';
        }
        return '';
    }

    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart
                data={props.data}
            >
                <XAxis dataKey="quarter" stroke="white" fontSize="1.5vh" />
                <YAxis stroke="white" fontSize="1.5vh" tickFormatter={(value: number) => numberFormatter(value, 0, '$')} />
                <Tooltip contentStyle={{ color: "white", backgroundColor: "rgb(26, 25, 22)" }} cursor={{ strokeDasharray: "3 3", fill:'#212121'}} content={customTooltip} />
                <Bar dataKey="actual" stackId="a" fill="#62b5e5" barSize={40}>
                    <LabelList dataKey='actual' fill="black" fontWeight={700} fontSize="1.2vh" formatter={(value: number) => value == 0 ? null : numberFormatter(value, 0, '$')} position="center"></LabelList>
                </Bar>
                <Bar dataKey="forecastedSpend" stackId="a" fill="#fcbe00" barSize={40}>
                    <LabelList dataKey='forecastedSpend' fill="black" fontWeight={700} fontSize="1.2vh" formatter={(value: number) => value == 0 ? null : numberFormatter(value, 0, '$')} position="center"></LabelList>
                </Bar>
                <Bar dataKey="spendNeededForNextTier" stackId="a" fill="#92d050" barSize={40}>
                    <LabelList dataKey='spendNeededForNextTier' fill="black" fontWeight={700} fontSize="1.2vh" formatter={(value: number) => value == 0 ? null : numberFormatter(value, 0, '$')} position="center"></LabelList>
                </Bar>

            </BarChart>
        </ResponsiveContainer >
    )
}

export default TargetSpend;